module.exports = __webpack_public_path__ + "img/ufo_black.a36b8417.png";